import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { companySelectedGuard } from './core/guards/company-selected.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    canActivate: [guestGuard],
  },
  {
    path: 'select-company',
    redirectTo: 'accounting',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout.component').then((m) => m.LayoutComponent),
    canActivate: [authGuard, companySelectedGuard],
    data: { breadcrumb: 'Accounting' },
    children: [
      {
        path: '',
        redirectTo: 'accounting',
        pathMatch: 'full',
      },
      {
        path: 'accounting',
        data: { breadcrumb: 'Accounting', preload: true },
        loadChildren: () =>
          import('./accounting/accounting.routes').then((m) => m.ACCOUNTING_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
